export type IDisplayOptionsVisibility = {
    hasCompanyInfosToggle: boolean;
    hasAccountsToggle: boolean;
    hasCoverSheetToggle: boolean;
    hasCompanyLogoToggle: boolean;
    hasUIDonCoverToggle: boolean;
    hasTableOfContentsToggle: boolean;
    hasDisableBalanceSheetPageBreakToggle: boolean;
    hasHideDecimalPlacesToggle: boolean;
    hasHideEmptyLinesToggle: boolean;
    hasHidePreviousYearToggle: boolean;
    hasFliTotalToggle: boolean;
    hasGroupHeadersToggle: boolean;
    hasGroupTotalsToggle: boolean;
    hasFcpToggle: boolean;
    hasAopToggle: boolean;
    hasCfsToggle: boolean;
    hasNotesToggle: boolean;
    hasComplementaryReportsToggle: boolean;
    hasEmsToggle: boolean;
    hasFasToggle: boolean;
    hasPrintInGrayscaleToggle: boolean;
    hasCustomPageNumbersToggle: boolean;
    hasReClassInSumsToggle: boolean;
    hasAdjustmentInSumsToggle: boolean;
    hasRatiosToggle: boolean;
    hasShareholderInformationToggle: boolean;
    hasAccountNumbersToggle: boolean;
    hasAccountProofForBalanceToggle: boolean;
    hasAccountProofForIncomeToggle: boolean;
    hasExperimentalOptions: boolean;
    hasAopHideDecimalPlacesValuesToggle: boolean;
    hasAopHideDecimalPlacesRatiosToggle: boolean;
    hasAopHideEmptyLinesToggle: boolean;
    hasNotesHideDecimalPlacesValuesToggle: boolean;
    hasNotesHideDecimalPlacesRatiosToggle: boolean;
    hasNotesHideEmptyLinesToggle: boolean;
    hasFinStatementHideDecimalPlacesValuesToggle: boolean;
    hasFinStatementHideDecimalPlacesRatiosToggle: boolean;
    hasFinStatementHideEmptyLinesToggle: boolean;
    hasFinStatementRoundToThousandsToggle: boolean;
    hasNotesRoundToThousandsToggle: boolean;
    hasAopRoundToThousandsToggle: boolean;
    hasPrintExportButtons: boolean;
    hasNonBreakingHyphenToggle: boolean;
    hasApplyGroupingMaskingToggle: boolean;
    hasRepeatAppendixTitleToggle: boolean;
};
